import * as styles from './index.module.scss';

const StateHero = (props) => (
  <div className={`${styles['state-hero-container']}`}>
    <div className="container">
      <h1>Find Home Service Professionals in {props.state?.label}</h1>
    </div>
  </div>
);

export default StateHero;
